module.exports = __webpack_public_path__ + "static/img/Header_1920x380_partner.7af1aa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/Header_1920x380_partner.jpg
// module id = A57I
// module chunks = 0